import { Component, OnDestroy, OnInit } from '@angular/core';
import {ApiService} from '../../services/api.service';
import {Automobilia} from '../../models/automobilia.model';
import { SearchService } from '../../services/search.service';
import {WantedItem} from '../../models/wanted-item.model';

@Component({
  selector: 'app-cars-wanted',
  templateUrl: './cars-wanted.component.html'
})
export class CarsWantedComponent implements OnInit, OnDestroy {

  title = [
    '_CARS_WANTED.TITLE_1',
    '_CARS_WANTED.TITLE_2'
  ];

  wantedCars: Array<WantedItem> = [];
  wantedCarsBackup: Array<WantedItem> = [];

  itemsPerPage = 25;
  currentPage = 1;
  scrollToggle: boolean;

  constructor(private api: ApiService,
              private searchService: SearchService) {
    this.searchService.doSearch.subscribe(searchTerm => {
      if (searchTerm) {
        this.updateSearch(searchTerm);
      } else {
        this.wantedCars = this.wantedCarsBackup;
      }
    });
  }

  ngOnInit() {
    this.searchService.active = true;
    this.searchService.searchTerm = '';
    this.searchService.reset();

    this.api.getWantedItemsActive(true).subscribe((activeItems: WantedItem[]) => {
      activeItems.sort((a, b) => {
        if (a.title < b.title) { return -1; }
        if (a.title > b.title) { return 1; }
        return 0;
      });

      this.wantedCars = activeItems;
      this.wantedCarsBackup = activeItems;
    });
  }

  ngOnDestroy(): void {
    this.searchService.active = false;
  }

  pageChange(event) {
    this.currentPage = event;
    this.scrollToggle = !this.scrollToggle;
  }

  updateSearch(searchTerm: string) {
    this.pageChange(1);
    this.wantedCars = this.wantedCarsBackup.filter((wantedItem: WantedItem, index) => {
      return (wantedItem.title.toLowerCase().search(searchTerm.toLowerCase()) !== -1)
        || (wantedItem.description.toLowerCase().search(searchTerm.toLowerCase()) !== -1);
    });
  }
}
